var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountEligibleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17191_66196)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.21071 14.2836C8.34848 14.4689 8.43648 14.5463 8.66113 14.6126C8.67687 14.6173 8.69489 14.6259 8.71045 14.631C8.78019 14.6541 8.87164 14.6264 8.93846 14.5926C9.0144 14.5541 9.04397 14.4701 9.01014 14.45C8.60402 14.2081 8.56535 14.2372 8.52728 13.8856C8.5239 13.8543 8.4324 13.8352 8.31291 13.8615C8.22545 13.8807 8.0762 13.8818 8.08451 13.9676C8.10409 14.1697 8.14996 14.2018 8.21071 14.2836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4734 13.4505C12.1528 13.6431 11.9041 13.9332 11.8287 14.282L11.5835 15.4158C11.4962 15.8194 11.1161 16.1097 10.6748 16.1097H8.26337C7.82211 16.1097 7.44201 15.8194 7.35472 15.4158L7.10033 14.2396C7.0261 13.8964 6.78395 13.6097 6.47091 13.4166C4.98207 12.4982 4 10.9222 4 9.1322C4 6.29776 6.46243 4 9.5 4C12.5376 4 15 6.29776 15 9.1322C15 10.9444 13.9934 12.5373 12.4734 13.4505Z",
    fill: "url(#paint0_radial_17191_66196)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.38334 6.38807C5.83488 6.95947 5.44463 7.64569 5.24438 8.38674C5.17072 8.65929 5.53138 8.92924 5.78889 9.045C6.04235 9.15894 6.35572 9.13853 6.38334 9.03959C6.74668 7.7382 8.02325 6.63565 9.35272 6.16079C9.46899 6.11926 9.4153 5.87147 9.15027 5.59833C8.93526 5.37674 8.6791 5.01094 8.3875 5.11241C7.62007 5.37943 6.93188 5.81665 6.38334 6.38807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.1447 13.302C10.7497 13.1966 11.31 12.954 11.7778 12.5964C11.9497 12.4651 11.9313 11.9546 11.744 12.065C11.7295 12.0735 11.7146 12.0838 11.6999 12.0948C10.8711 12.7177 9.355 12.9789 8.31055 12.6889C8.25815 12.6744 8.18923 12.6308 8.141 12.6198C7.90926 12.5672 8.08256 13.1351 8.31055 13.2003C8.91017 13.372 9.5396 13.4073 10.1447 13.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_17191_66196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.36743 16.4067C7.36743 16.1047 7.52144 15.8599 7.71141 15.8599H11.2888C11.4787 15.8599 11.6327 16.1047 11.6327 16.4067C11.6327 16.7086 11.4787 16.9534 11.2888 16.9534H7.71141C7.52144 16.9534 7.36743 16.7086 7.36743 16.4067Z",
    fill: "url(#paint1_linear_17191_66196)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_17191_66196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.36743 17.5004C7.36743 17.1984 7.52144 16.9536 7.71141 16.9536H11.2888C11.4787 16.9536 11.6327 17.1984 11.6327 17.5004C11.6327 17.8024 11.4787 18.0472 11.2888 18.0472H7.71141C7.52143 18.0472 7.36743 17.8024 7.36743 17.5004Z",
    fill: "url(#paint2_linear_17191_66196)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_17191_66196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.36743 18.5942C7.36743 18.2922 7.52144 18.0474 7.71141 18.0474H11.2888C11.4787 18.0474 11.6327 18.2922 11.6327 18.5942C11.6327 18.8961 11.4787 19.1409 11.2888 19.1409H7.71141C7.52143 19.1409 7.36743 18.8961 7.36743 18.5942Z",
    fill: "url(#paint3_linear_17191_66196)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.004 18.7061C11.2501 18.7061 11.4546 18.8401 11.3989 18.9992C11.3748 19.068 11.3421 19.1356 11.3012 19.2012C11.2032 19.3581 11.0596 19.5008 10.8786 19.6209C10.6975 19.7411 10.4826 19.8364 10.246 19.9014C10.0095 19.9664 9.75599 19.9999 9.49996 19.9999C9.24393 19.9999 8.99041 19.9664 8.75387 19.9014C8.51733 19.8364 8.30241 19.7411 8.12137 19.6209C7.94033 19.5008 7.79672 19.3581 7.69874 19.2012C7.65781 19.1356 7.62517 19.068 7.60104 18.9992C7.54528 18.8401 7.74985 18.7061 7.99596 18.7061H11.004Z",
    fill: "url(#paint4_radial_17191_66196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13574 15.6562C3.33087 15.4611 3.64748 15.4614 3.84277 15.6562C4.03803 15.8515 4.03803 16.168 3.84277 16.3633L3.13574 17.0713C2.94048 17.2661 2.62385 17.2663 2.42871 17.0713C2.23345 16.876 2.23345 16.5585 2.42871 16.3633L3.13574 15.6562ZM15.1562 15.6572C15.3515 15.462 15.669 15.462 15.8643 15.6572L16.5713 16.3643C16.7662 16.5595 16.7664 16.8761 16.5713 17.0713C16.3762 17.2664 16.0595 17.2662 15.8643 17.0713L15.1562 16.3643C14.9612 16.1691 14.9615 15.8525 15.1562 15.6572ZM1.5 9.5C1.77614 9.5 2 9.72386 2 10C2 10.2761 1.77614 10.5 1.5 10.5H0.5C0.223858 10.5 7.03532e-08 10.2761 0 10C2.41411e-08 9.72386 0.223858 9.5 0.5 9.5H1.5ZM19.5 9.5C19.7761 9.5 20 9.72386 20 10C20 10.2761 19.7761 10.5 19.5 10.5H18.5C18.2239 10.5 18 10.2761 18 10C18 9.72386 18.2239 9.5 18.5 9.5H19.5ZM15.8643 2.92871C16.0595 2.7338 16.3761 2.73365 16.5713 2.92871C16.7664 3.12387 16.7662 3.44045 16.5713 3.63574L15.8643 4.34375C15.6691 4.53878 15.3525 4.53859 15.1572 4.34375C14.962 4.14849 14.962 3.831 15.1572 3.63574L15.8643 2.92871ZM2.42871 2.92871C2.62397 2.73345 2.94146 2.73345 3.13672 2.92871L3.84375 3.63574C4.03879 3.83092 4.03869 4.14753 3.84375 4.34277C3.64853 4.53799 3.33199 4.5379 3.13672 4.34277L2.42871 3.63574C2.2338 3.44053 2.23375 3.1239 2.42871 2.92871ZM9.5 0C9.77614 1.20706e-08 10 0.223858 10 0.5V1.5C10 1.77614 9.77614 2 9.5 2C9.22386 2 9 1.77614 9 1.5V0.5C9 0.223858 9.22386 -1.20706e-08 9.5 0Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_17191_66196",
    x: 7.36743,
    y: 15.8599,
    width: 4.26526,
    height: 1.39375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17191_66196"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_17191_66196",
    x: 7.36743,
    y: 16.9536,
    width: 4.26526,
    height: 1.39375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17191_66196"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_17191_66196",
    x: 7.36743,
    y: 18.0474,
    width: 4.26526,
    height: 1.39375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17191_66196"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17191_66196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.86667 11.8305 -13.3203 -3.56934 10.6 7.47957)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355769,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476794,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668269,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17191_66196",
    x1: 10.5203,
    y1: 19.1489,
    x2: 10.6587,
    y2: 15.7387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.564998,
    stopColor: "#9DAAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17191_66196",
    x1: 10.5203,
    y1: 20.2427,
    x2: 10.6587,
    y2: 16.8325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.564998,
    stopColor: "#9DAAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17191_66196",
    x1: 10.5203,
    y1: 21.3364,
    x2: 10.6587,
    y2: 17.9262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.564998,
    stopColor: "#9DAAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_17191_66196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0.708231 0.981451 -2.89496 1.00294 9.55517 18.4501)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBAC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D535A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17191_66196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountEligibleIcon);
export default __webpack_public_path__ + "static/media/discount-eligible-icon.cd34cbe8dc2a4cf9d6a8921019ac6382.svg";
export { ForwardRef as ReactComponent };